import {useDispatch, useSelector} from "react-redux";
import { useLocation } from "react-router-dom";
import { googleLogout } from "@react-oauth/google";
import { history } from "../../utils/history";
import { ROUTERS_MAP } from "../../utils/routes";

import {
    CalendarLogOut,
    ClearUserInfoGoogleService,
    DeleteOutlookAuth,
    GetAuthorizationUrlOutlook,
    GetCalendarSynchronize,
    GetGoogleAuth,
    GetUserCalendars, GetVideosService,
    UpdateConfluenceInfoService
} from "../../redux/actions";

import {
    DisconnectGoogleEmailInfoService,
    GetAuthorizationUrlConfluenceService,
    LogoutConfluenceService
} from "../../redux/actions/integrationsActions";

import { UpdateActiveStep } from "../../redux/actions/tourActions";
import {
    KEY_LOCAL_STORAGE_SUCCESS_TOUR_STEP_1, KEY_LOCAL_STORAGE_SUCCESS_TOUR_STEP_2,
    KEY_LOCAL_STORAGE_SUCCESS_TOUR_STEP_3,
    KEY_LOCAL_STORAGE_SUCCESS_TOUR_STEP_4,
    KEY_LOCAL_STORAGE_SUCCESS_TOUR_STEP_5,
    KEY_LOCAL_STORAGE_SUCCESS_TOUR_STEP_6,
    STEPS
} from "./helpers";
import {CloseChat} from "../../redux/actions/chatActions";

export const useTourActions = () => {
    const dispatch = useDispatch();
    const location = useLocation();
    const channels = useSelector(state => state.channels?.channels || []);
    const isNextStepThree = channels.some((item) => item.videos_count > 0);
    const videosList = useSelector(state => state.videos?.videosList?.results || []);

    const isCurrentPath = (route) => location?.pathname.includes(route);
    const isStepComplete = (key) => Boolean(localStorage.getItem(key));
    const sendEvent = (key) => {
        localStorage.setItem(key,String(true));
        window.dispatchEvent(
            new CustomEvent("localstorage-change", {
                detail: {key, value: true}
            })
        )
    };

    const goToStep = (step, route, key) => {
        dispatch(CloseChat());
        if (!isCurrentPath(key)) {
            history.push(route)
        }
        setTimeout(()=>{
            dispatch(UpdateActiveStep(step));
        },500)
    };

    const handleClickNextStep1List = () => {
        dispatch(CloseChat());
        goToStep(STEPS.ONE, ROUTERS_MAP.KNOWLEDGE_DATA);
    };


    const handleClickNextStep2List = () => {
        dispatch(CloseChat());
        goToStep(STEPS.TWO, ROUTERS_MAP.KNOWLEDGE_DATA);
    };

    const handleClickNextStep2 = () => {
        dispatch(CloseChat());
        sendEvent(KEY_LOCAL_STORAGE_SUCCESS_TOUR_STEP_2);

        if (isNextStepThree) {
            handleClickNextStep3List();
        } else {
            goToStep(STEPS.FIVE, ROUTERS_MAP.COPILOT);
        }
    };

    const handleClickNextStep3List = async () => {
        dispatch(CloseChat());
        if(!isCurrentPath('/dashboard/videos/video/')){
                let video = null;
                debugger;
                if(videosList?.[videosList.length - 1]?.id){
                    video = videosList?.[videosList.length - 1]
                }else{
                   const videos = await dispatch(GetVideosService({
                        limit: 1,
                        sort_by: 'creation_time'
                    }, true));

                   video = videos?.results?.[0];
                }

                if(video?.id){
                    goToStep(STEPS.THREE, `/dashboard/videos/video/${video?.id}`,'/dashboard/videos/video/');
                }
            }else{
                setTimeout(()=>{
                    dispatch(UpdateActiveStep(STEPS.THREE));
                },500)
            }
    };

    const handleClickNextStep3 = () => {
        dispatch(CloseChat());
        sendEvent(KEY_LOCAL_STORAGE_SUCCESS_TOUR_STEP_3);
        goToStep(STEPS.FOUR, ROUTERS_MAP.INTEGRATIONS);
    };

    const handleClickNextStep4List = () => {
        dispatch(CloseChat());
        goToStep(STEPS.FOUR, ROUTERS_MAP.INTEGRATIONS);
    };

    const handleClickNextStep4 = () => {
        dispatch(CloseChat());
        sendEvent(KEY_LOCAL_STORAGE_SUCCESS_TOUR_STEP_4);
        goToStep(STEPS.FIVE, ROUTERS_MAP.COPILOT);
    };

    const handleClickNextStep5List = () => {
        dispatch(CloseChat());
        goToStep(STEPS.FIVE, ROUTERS_MAP.COPILOT);
    };

    const handleClickNextStep5 = () => {
        dispatch(CloseChat());
        sendEvent(KEY_LOCAL_STORAGE_SUCCESS_TOUR_STEP_5);
        goToStep(STEPS.SIX, ROUTERS_MAP.AI_AGENTS);
    };

    const handleClickNextStep6List = () => {
        dispatch(CloseChat());
        goToStep(STEPS.SIX, ROUTERS_MAP.AI_AGENTS);
    };

    const handleClickNextStep6 = () => {
        dispatch(CloseChat());
        sendEvent(KEY_LOCAL_STORAGE_SUCCESS_TOUR_STEP_6);
        goToStep(STEPS.SEVEN, ROUTERS_MAP.AI_AGENTS);
    };

    const isStep5Complete = () => isCurrentPath(ROUTERS_MAP.COPILOT);

    return {
        handleClickNextStep1List,
        handleClickNextStep2List,
        handleClickNextStep3List,
        handleClickNextStep4List,
        handleClickNextStep5List,
        handleClickNextStep6List,
        handleClickNextStep2,
        handleClickNextStep3,
        handleClickNextStep4,
        handleClickNextStep5,
        handleClickNextStep6,
        isStep5Complete
    };
};
